import React, { FC, ReactChild } from "react"
import { container } from "./styles"
/** @jsx jsx */
import { jsx } from "@emotion/react"
interface ParagraphProps {
  children?: ReactChild
}

/**
 * Paragraph component for terms of use
 *
 * @param {*} { children }
 * @returns
 */
const Paragraph: FC<ParagraphProps> = ({ children }) => {
  return <div css={container}>{children}</div>
}

export default Paragraph
